import RentAdvance from "./pages/rent-advance";

export const RentAdvancePage = RentAdvance;
